export const MAX_BILLING_CONTACTS = 3

export const CONSOLE_LOG_KEY = '[Billing Contacts Modal]'
